import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControl, Select, Table, TableBody, Typography } from '@material-ui/core';
import _ from 'lodash';
import ApplicationTableHeader from './ApplicationTableHeader';
import ValidationError from './ValidationError';
import ApplicationTableRow from './ApplicationTableRow';

const PointsWithLimitUniquenessConstraintField = ({ values, max, usedValues, input, meta: { error, touched }, groupByDistricts, districts }) => {
  const categoriesEnabled = values.filter(a => a.category !== null).length > 0;
  const subcategoriesEnabled = values.filter(a => a.subcategory !== null).length > 0;
  
  const renderTable = (applications, categoriesEnabled, subcategoriesEnabled, input) => (
    <Table className="projects-table">
      <ApplicationTableHeader categoriesEnabled={categoriesEnabled} subcategoriesEnabled={subcategoriesEnabled} leftAction rightActionLabel="Ilość punktów" />
      <TableBody>
        {applications.map(application => (
          <ApplicationTableRow
            key={application.id}
            application={application}
            leftAction={<Checkbox
              checked={input.value && input.value.some(i => i.applicationId === application.id) ? true : false}
              disabled
              color="primary"
            />}
            categoriesEnabled={categoriesEnabled}
            subcategoriesEnabled={subcategoriesEnabled}
            rightAction={
              <FormControl style={{ width: 66 }}>
                <Select
                  native
                  value={input.value && input.value.some(i => i.applicationId === application.id) ? input.value.find(i => i.applicationId === application.id).value : ''}
                  onChange={event => {
                    if (event.target.value) {
                      const value = Number.parseInt(event.target.value);
                      input.onChange([...input.value.filter(i => i.applicationId !== application.id), { applicationId: application.id, value }]);
                    } else {
                      input.onChange([...input.value.filter(i => i.applicationId !== application.id)]);
                    }

                    input.onBlur();
                  }}
                >
                  <option value="">brak</option>
                  {_.range(1, max + 1).map(value => (
                    <option key={value} value={value} disabled={usedValues && usedValues.includes(value)}>{value}</option>
                  ))}
                </Select>
              </FormControl>
            }
          />)
        )}
      </TableBody>
    </Table>);

    return (
      <React.Fragment>
        <div className="box">
          <div className="col-sm-12">
            <Typography variant="body2" style={{ marginBottom: 30 }}>Rozdysponuj punkty pomiędzy wybrane projekty. Wartości do rozdysponowania to <strong>{_.range(1, max + 1).join(', ')}</strong></Typography>
            
            {groupByDistricts ||categoriesEnabled
              ? _(values)
              .groupBy(x => groupByDistricts ? x.district : x.category)
                .map((value, key) => ({ key, applications: value}))
                .sortBy(x => groupByDistricts ? districts.indexOf(x.key) : ['key'])
                .value()
                .map(x => (
                  <div key={x.key} style={{ marginBottom: 30 }}>
                    <h3 className="category"><i className="fa fa-bookmark" /> <span>{groupByDistricts ? 'Obszar' : 'Kategoria'}</span> {x.key}</h3>
                    {renderTable(x.applications, groupByDistricts ? categoriesEnabled : false, subcategoriesEnabled, input)}
                  </div>))
            : renderTable(values, categoriesEnabled, subcategoriesEnabled, input)}
        </div>
      </div>
      {error && touched ? <ValidationError error={error} /> : null}
    </React.Fragment>);
};

PointsWithLimitUniquenessConstraintField.propTypes = {
  values: PropTypes.array.isRequired,
  max: PropTypes.number.isRequired,
  usedValues: PropTypes.array.isRequired,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  groupByDistricts: PropTypes.bool.isRequired,
  districts: PropTypes.array,
};

export default PointsWithLimitUniquenessConstraintField;



// WEBPACK FOOTER //
// ./src/components/budget/types/PointsWithLimitUniquenessConstraintField.js